import { Injectable } from '@angular/core';
import { EChartsOption } from 'echarts';
import { Observable, Subject } from 'rxjs';
import { ClimateChart, YAxis } from '../../../model/climate/climate-chart';
import { getSSPColor } from './custom-theme';
import { ClimateChartHelper } from './util/climate-chart-helper';

@Injectable()
export class CoolingDegreeDaysChangeService {

  private readonly locationChartSubject = new Subject<any>();
  private readonly addressChartSubject = new Subject<any>();

  emitLocationChartEvent(chartInstance: any): void { this.locationChartSubject.next(chartInstance); }
  getLocationChartSubject(): Observable<any> { return this.locationChartSubject.asObservable(); }
  emitAddressChartEvent(chartInstance: any): void { this.addressChartSubject.next(chartInstance); }
  getAddressChartSubject(): Observable<any> { return this.addressChartSubject.asObservable(); }

  options: EChartsOption = ClimateChartHelper.getDefaultChartOptions(
    'Change in Cooling degree-days', 'Change in Cooling Degree-Days', 'Cooling_Degree_Days_Change'
  );

  updateCoolingDegreeDaysChangeChart(echartsInstance: any, climateChart: ClimateChart) {
    const yAxis: YAxis = climateChart.chartConfig.yAxis;
    const { seriesData, source } = ClimateChartHelper.buildChartData(climateChart, getSSPColor);
    const bounds = ClimateChartHelper.calculateAxisBounds(climateChart.series, yAxis.min, yAxis.max, yAxis.interval);

    echartsInstance.setOption({
      animation: false,
      xAxis: ClimateChartHelper.getDualXAxisConfig(),
      yAxis: [{
        type: 'value', scale: true, name: yAxis.title || 'Change in Cooling degree-days',
        min: bounds.min, max: bounds.max, interval: bounds.interval,
        position: 'left', alignTicks: true, axisLine: { show: true },
        axisLabel: { formatter: '{value} ' }, boundaryGap: [0.2, 0.2]
      }],
      dataset: { source },
      series: seriesData
    });

    ClimateChartHelper.attachDownloadHandler(echartsInstance, 'Changing temperature air - Cooling degree days (CD)', 'Changing_temperature_air_Cooling_degree_days_CD_Change');
    ClimateChartHelper.attachDualXAxisHandler(echartsInstance);
  }
}
